module.exports = __webpack_public_path__ + "c32a5889d2c106ac1f11a545d7157785.png";